import { IProperty } from 'interfaces/IProperty';
import { IPropertyExpense } from 'interfaces/inputs/IPropertyExpense';

export const getYearFromDate = (date?: string | null) => {
  return date?.split('-')[0];
};

export const getExpenseFromQuoteDate = (
  date?: string,
  leaseProperty?: IProperty,
): IPropertyExpense | undefined => {
  let quoteExpense: IPropertyExpense | undefined;
  if (leaseProperty?.expenses) {
    quoteExpense = leaseProperty.expenses.find(
      x => x.year === Number(getYearFromDate(date)),
    );
  }

  return quoteExpense;
};

export const calculateTaxAndOpexTotal = (
  tax: number | undefined | null,
  opex: number | undefined | null,
): number | undefined => {
  const taxDefined = tax !== undefined && tax !== null;
  const opexDefined = opex !== undefined && opex !== null;
  return taxDefined && opexDefined
    ? Math.round((tax! + opex!) * 100) / 100
    : undefined;
};
